import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatTravellerPrompt, ChatTravellerRow } from '@sabstravtech/obtservices/base';

import { ChatWidgetInputBase } from '../chat-widget-input-base';

/**
 * Traveller card for booking on behalf of others (ENT-16454). Lists the
 * travellers ai-agents resolved or set, and offers chips whose label is sent
 * back as the user's next message. Locked on every message but the last,
 * like the approver picker.
 */
@Component({
  selector: 'app-chat-traveller-card',
  standalone: false,
  templateUrl: './chat-traveller-card.component.html',
  styleUrls: ['./chat-traveller-card.component.scss']
})
export class ChatTravellerCardComponent extends ChatWidgetInputBase {
  @Input() prompt!: ChatTravellerPrompt;
  @Output() chip = new EventEmitter<string>();

  get title(): string {
    switch (this.prompt.kind) {
      case 'choose':
        return $localize`:@@chatTravellerSelectTitle:Select traveller`;
      case 'denied':
        return $localize`:@@chatTravellerDeniedTitle:Not on your traveller list`;
      default:
        return this.prompt.travellers.length > 1
          ? $localize`:@@chatTravellersTitle:Travellers`
          : $localize`:@@chatTravellerTitle:Traveller`;
    }
  }

  initials(row: ChatTravellerRow): string {
    return row.name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join('');
  }

  onChip(label: string): void {
    if (this.locked) {
      return;
    }
    this.chip.emit(label);
  }
}
